import $ from 'jquery'

var pdfSectionsShow = function($element) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      $pdfFile;

  /* PRIVATE METHODS */

  // constructor
  function init() {
    $pdfFile = $('.pdf-file', $mainContainer);

    bindDomEvents();
  }

  function bindDomEvents() {
    if ($pdfFile.length) pdfJsRender();
  }

  // run constructor
  init();

  function pdfJsRender() {
    var pdfPath = $pdfFile.data('pdfFile'),
        pdfWorker = $pdfFile.data('pdfWorker'),
        $pdfContainer = $('.pdf-file', $mainContainer),
        sectionId = $pdfFile.data('sectionId'),
        canvasId = 'canvas_' + sectionId;

    SOPHIA.pdfViewer(pdfPath, pdfWorker, $pdfContainer, canvasId);
  }

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };
};

// jQuery plugin method
$.fn.pdfSectionsShow = function() {
  return this.each(function() {
    pdfSectionsShow($(this));
  });
};

